var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "carousel-controls" }, [
    _c(
      "button",
      {
        staticClass: "prev",
        attrs: { role: "button" },
        on: {
          click: function ($event) {
            return _vm.handleOnClick(-1)
          },
        },
      },
      [_vm._v("❮")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "next",
        attrs: { role: "button" },
        on: {
          click: function ($event) {
            return _vm.handleOnClick(1)
          },
        },
      },
      [_vm._v("❯")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }